var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrototyping3X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "364px",
    height: "364px",
    viewBox: "0 0 364 364",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Prototyping") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-/-S2-01-1_Landing_page-1",
    transform: "translate(-344.000000, -1896.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prototyping",
    transform: "translate(344.054240, 1896.054240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.19576,40.9457597 C258.653696,40.9457597 321.44576,103.737824 321.44576,181.19576 C321.44576,258.653696 258.653696,321.44576 181.19576,321.44576 C150.448947,321.44576 125.523731,296.520544 125.523731,265.773731 C125.523731,255.42908 128.405958,245.289019 133.847106,236.490967 C145.246208,218.059231 150.94576,199.627495 150.94576,181.19576 C150.94576,162.764024 145.246208,144.332288 133.847106,125.900552 C117.674687,99.7506126 125.763061,65.4415611 151.912998,49.2691385 C160.711047,43.827987 170.851109,40.9457597 181.19576,40.9457597 Z",
    id: "Rectangle",
    fill: "#6551FF",
    opacity: 0.100000001,
    transform: "translate(181.195760, 181.195760) scale(-1, 1) rotate(21.000000) translate(-181.195760, -181.195760) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-81",
    transform: "translate(23.945760, 68.745760)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#3420FA",
    transform: "translate(33.138194, 84.495113) rotate(-19.000000) translate(-33.138194, -84.495113) ",
    points: "19.8454489 33.3087497 33.3038951 33.3084218 46.43094 135.681476 32.9724938 135.681804"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8333053,40.6082801 C27.7716902,40.6082801 29.4273225,42.006634 29.7516135,43.9176996 L43.2298961,123.345993 C43.4918515,124.889711 42.4527773,126.353499 40.9090589,126.615454 C40.7523544,126.642046 40.5936912,126.655412 40.4347466,126.655412 C38.4963616,126.655412 36.8407294,125.257058 36.5164384,123.345993 L23.0381558,43.9176996 C22.7762003,42.3739812 23.8152745,40.9101933 25.358993,40.6482378 C25.5156975,40.6216465 25.6743606,40.6082801 25.8333053,40.6082801 Z",
    id: "Rectangle-Copy-32",
    fill: "#8AB2FF",
    transform: "translate(33.134026, 83.631846) rotate(-19.000000) translate(-33.134026, -83.631846) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#5746FF",
    points: "30.6 192.1 107.95 192.1 107.95 195.5 30.6 195.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5,125.8 L96.05,125.8 C98.3972102,125.8 100.3,127.70279 100.3,130.05 L100.3,185.3 L100.3,185.3 L38.25,185.3 L38.25,130.05 C38.25,127.70279 40.1527898,125.8 42.5,125.8 Z",
    id: "Rectangle-Copy-5",
    fill: "#5746FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4,132.6 L100.3,132.6 C102.64721,132.6 104.55,134.50279 104.55,136.85 L104.55,192.1 L104.55,192.1 L33.15,192.1 L33.15,136.85 C33.15,134.50279 35.0527898,132.6 37.4,132.6 Z",
    id: "Rectangle",
    fill: "#FF655A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.47134,181.9 L199.27866,181.9 C200.20956,181.9 201.066489,182.407271 201.51427,183.223401 L206.177915,191.723401 C206.855348,192.958094 206.403598,194.508178 205.168904,195.18561 C204.792974,195.39187 204.371101,195.5 203.942305,195.5 L114.807695,195.5 C113.399369,195.5 112.257695,194.358326 112.257695,192.95 C112.257695,192.521204 112.365825,192.099331 112.572085,191.723401 L117.23573,183.223401 C117.683511,182.407271 118.54044,181.9 119.47134,181.9 Z",
    id: "Rectangle",
    fill: "#210097"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#120065",
    points: "135.37973 159.8 181.67027 159.8 186.15 181.9 130.9 181.9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1C0089",
    x: 36.55,
    y: 20.4,
    width: 244.8,
    height: 139.4,
    rx: 13.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#8795D9",
    strokeWidth: 0.85,
    fill: "#5841AA",
    cx: 158.95,
    cy: 154.7,
    r: 2.975
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0143537,25.667563 L263.697224,29.7613721 C269.252618,29.8688098 273.7,34.4030332 273.7,39.9594652 L273.7,134.973526 C273.7,142.484599 267.611073,148.573526 260.1,148.573526 C260.041555,148.573526 259.983111,148.57315 259.924671,148.572396 L55.0965872,145.931568 C48.5847733,145.847612 43.35,140.544912 43.35,134.032557 L43.35,34.1659739 C43.35,29.4715535 47.1555796,25.6659739 51.85,25.6659739 C51.9047884,25.6659739 51.9595756,25.6665036 52.0143537,25.667563 Z",
    id: "Rectangle-Copy-4",
    fill: "#7E99EA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-58",
    transform: "translate(46.750000, 28.900000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.3043867,0.992594646 L135.900387,2.75111083 C141.438494,2.88166545 145.86,7.40863137 145.86,12.9482778 L145.86,106.006713 C145.86,111.640017 141.293304,116.206713 135.66,116.206713 C135.579863,116.206713 135.499728,116.205768 135.419613,116.20388 L60.8236133,114.445364 C55.2855055,114.314809 50.864,109.787843 50.864,104.248197 L50.864,11.1897616 C50.864,5.55645717 55.4306956,0.989761618 61.064,0.989761618 C61.1441372,0.989761618 61.2242717,0.990706027 61.3043867,0.992594646 Z",
    id: "Rectangle",
    fill: "#C6D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2,0 L37.672,0 C43.3053044,-2.81117808e-15 47.872,4.56669555 47.872,10.2 L47.872,104.010577 C47.872,109.643881 43.3053044,114.210577 37.672,114.210577 L10.2,114.210577 C4.56669555,114.210577 6.41859315e-15,109.643881 0,104.010577 L0,10.2 C-2.46623767e-15,4.56669555 4.56669555,-4.29424928e-15 10.2,0 Z",
    id: "Rectangle-Copy-22",
    fill: "#C6D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.46213,86.5915038 L86.39787,86.5905451 C87.4284999,86.5905085 88.2640203,87.4259694 88.264057,88.4565994 C88.264057,88.4566215 88.264057,88.4566436 88.264057,88.4566658 C88.264057,89.4873432 87.4285474,90.3228826 86.39787,90.3229193 L59.46213,90.3238779 C58.4315001,90.3239146 57.5959797,89.4884537 57.595943,88.4578237 C57.595943,88.4578016 57.595943,88.4577794 57.595943,88.4577573 C57.595943,87.4270799 58.4314526,86.5915405 59.46213,86.5915038 Z",
    id: "Rectangle-Copy-19",
    fill: "#CDDFFF",
    transform: "translate(72.930000, 88.457212) rotate(1.000000) translate(-72.930000, -88.457212) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.46213,94.0562474 L86.39787,94.0552887 C87.4284999,94.0552521 88.2640203,94.890713 88.264057,95.921343 C88.264057,95.9213651 88.264057,95.9213872 88.264057,95.9214094 C88.264057,96.9520868 87.4285474,97.7876262 86.39787,97.7876629 L59.46213,97.7886215 C58.4315001,97.7886582 57.5959797,96.9531973 57.595943,95.9225673 C57.595943,95.9225452 57.595943,95.922523 57.595943,95.9225009 C57.595943,94.8918235 58.4314526,94.0562841 59.46213,94.0562474 Z",
    id: "Rectangle-Copy-20",
    fill: "#CDDFFF",
    transform: "translate(72.930000, 95.921955) rotate(1.000000) translate(-72.930000, -95.921955) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.46213,72.408491 L86.39787,72.4075323 C87.4284999,72.4074956 88.2640203,73.2429566 88.264057,74.2735865 C88.264057,74.2736087 88.264057,74.2736308 88.264057,74.273653 C88.264057,75.3043304 87.4285474,76.1398698 86.39787,76.1399064 L59.46213,76.1408651 C58.4315001,76.1409018 57.5959797,75.3054409 57.595943,74.2748109 C57.595943,74.2747887 57.595943,74.2747666 57.595943,74.2747445 C57.595943,73.2440671 58.4314526,72.4085277 59.46213,72.408491 Z",
    id: "Rectangle-Copy-19",
    fill: "#CDDFFF",
    transform: "translate(72.930000, 74.274199) rotate(1.000000) translate(-72.930000, -74.274199) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.46213,62.7043243 L86.39787,62.7033657 C87.4284999,62.703329 88.2640203,63.5387899 88.264057,64.5694199 C88.264057,64.569442 88.264057,64.5694642 88.264057,64.5694863 C88.264057,65.6001637 87.4285474,66.4357031 86.39787,66.4357398 L59.46213,66.4366984 C58.4315001,66.4367351 57.5959797,65.6012742 57.595943,64.5706442 C57.595943,64.5706221 57.595943,64.5705999 57.595943,64.5705778 C57.595943,63.5399004 58.4314526,62.704361 59.46213,62.7043243 Z",
    id: "Rectangle-Copy-19",
    fill: "#CDDFFF",
    transform: "translate(72.930000, 64.570032) rotate(1.000000) translate(-72.930000, -64.570032) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.46213,79.8732346 L86.39787,79.8722759 C87.4284999,79.8722392 88.2640203,80.7077002 88.264057,81.7383301 C88.264057,81.7383523 88.264057,81.7383744 88.264057,81.7383966 C88.264057,82.769074 87.4285474,83.6046134 86.39787,83.60465 L59.46213,83.6056087 C58.4315001,83.6056454 57.5959797,82.7701844 57.595943,81.7395545 C57.595943,81.7395323 57.595943,81.7395102 57.595943,81.7394881 C57.595943,80.7088107 58.4314526,79.8732713 59.46213,79.8732346 Z",
    id: "Rectangle-Copy-20",
    fill: "#CDDFFF",
    transform: "translate(72.930000, 81.738942) rotate(1.000000) translate(-72.930000, -81.738942) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-78",
    transform: "translate(148.852000, 2.239423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-80",
    fill: "#C6D9FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2,0 L65.348,0 C70.9813044,-1.03482124e-15 75.548,4.56669555 75.548,10.2 L75.548,52.5038462 C75.548,58.1371506 70.9813044,62.7038462 65.348,62.7038462 L10.2,62.7038462 C4.56669555,62.7038462 6.00474049e-15,58.1371506 5.31485966e-15,52.5038462 L5.31485966e-15,10.2 C6.40133568e-15,4.56669555 4.56669555,1.03482124e-15 10.2,0 Z",
    id: "Rectangle-Copy-22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-80",
    transform: "translate(0.000000, 65.689744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2,0 L65.348,0 C70.9813044,-1.03482124e-15 75.548,4.56669555 75.548,10.2 L75.548,38.3208333 C75.548,43.9541378 70.9813044,48.5208333 65.348,48.5208333 L10.2,48.5208333 C4.56669555,48.5208333 6.89880826e-16,43.9541378 0,38.3208333 L0,10.2 C1.08647601e-15,4.56669555 4.56669555,2.81117808e-15 10.2,0 Z",
    id: "Rectangle-Copy-22",
    fill: "#C6D9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    fill: "#CDDFFF",
    x: 6.25877551,
    y: 21.6477564,
    width: 61.336,
    height: 3.73237179,
    rx: 1.8661859
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-17",
    fill: "#CDDFFF",
    x: 6.25877551,
    y: 29.1125,
    width: 61.336,
    height: 3.73237179,
    rx: 1.8661859
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-18",
    fill: "#CDDFFF",
    x: 6.25877551,
    y: 36.5772436,
    width: 61.336,
    height: 3.73237179,
    rx: 1.8661859
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M93.1209671,86.2910931 L137.241317,88.3844677 C138.282838,88.4338847 139.099928,89.2961356 139.093297,90.338807 C139.087007,91.3278591 138.280122,92.1245451 137.29107,92.1182549 C137.266564,92.118099 137.242063,92.1174401 137.217584,92.1162787 L93.0972335,90.0229041 C92.0557127,89.9734871 91.2386227,89.1112362 91.2452539,88.0685648 C91.2515441,87.0795127 92.0584284,86.2828267 93.0474806,86.2891169 C93.071987,86.2892728 93.0964877,86.2899317 93.1209671,86.2910931 Z",
    id: "Rectangle-Copy-19",
    fill: "#CDDFFF",
    transform: "translate(115.169275, 89.203686) rotate(-2.000000) translate(-115.169275, -89.203686) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1209671,93.7558367 L137.241317,95.8492113 C138.282838,95.8986283 139.099928,96.7608792 139.093297,97.8035506 C139.087007,98.7926027 138.280122,99.5892886 137.29107,99.5829985 C137.266564,99.5828426 137.242063,99.5821837 137.217584,99.5810223 L93.0972335,97.4876476 C92.0557127,97.4382307 91.2386227,96.5759798 91.2452539,95.5333084 C91.2515441,94.5442563 92.0584284,93.7475703 93.0474806,93.7538605 C93.071987,93.7540164 93.0964877,93.7546753 93.1209671,93.7558367 Z",
    id: "Rectangle-Copy-20",
    fill: "#CDDFFF",
    transform: "translate(115.169275, 96.668429) rotate(-2.000000) translate(-115.169275, -96.668429) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1209671,72.1080803 L137.241317,74.2014549 C138.282838,74.2508719 139.099928,75.1131228 139.093297,76.1557941 C139.087007,77.1448463 138.280122,77.9415322 137.29107,77.935242 C137.266564,77.9350862 137.242063,77.9344273 137.217584,77.9332658 L93.0972335,75.8398912 C92.0557127,75.7904743 91.2386227,74.9282234 91.2452539,73.885552 C91.2515441,72.8964999 92.0584284,72.0998139 93.0474806,72.1061041 C93.071987,72.10626 93.0964877,72.1069188 93.1209671,72.1080803 Z",
    id: "Rectangle-Copy-19",
    fill: "#CDDFFF",
    transform: "translate(115.169275, 75.020673) rotate(-2.000000) translate(-115.169275, -75.020673) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1209671,62.4039136 L137.241317,64.4972883 C138.282838,64.5467052 139.099928,65.4089561 139.093297,66.4516275 C139.087007,67.4406796 138.280122,68.2373656 137.29107,68.2310754 C137.266564,68.2309195 137.242063,68.2302606 137.217584,68.2290992 L93.0972335,66.1357246 C92.0557127,66.0863076 91.2386227,65.2240567 91.2452539,64.1813853 C91.2515441,63.1923332 92.0584284,62.3956473 93.0474806,62.4019374 C93.071987,62.4020933 93.0964877,62.4027522 93.1209671,62.4039136 Z",
    id: "Rectangle-Copy-19",
    fill: "#CDDFFF",
    transform: "translate(115.169275, 65.316506) rotate(-2.000000) translate(-115.169275, -65.316506) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1209671,79.5728239 L137.241317,81.6661985 C138.282838,81.7156155 139.099928,82.5778664 139.093297,83.6205377 C139.087007,84.6095899 138.280122,85.4062758 137.29107,85.3999856 C137.266564,85.3998298 137.242063,85.3991709 137.217584,85.3980094 L93.0972335,83.3046348 C92.0557127,83.2552179 91.2386227,82.392967 91.2452539,81.3502956 C91.2515441,80.3612435 92.0584284,79.5645575 93.0474806,79.5708477 C93.071987,79.5710036 93.0964877,79.5716624 93.1209671,79.5728239 Z",
    id: "Rectangle-Copy-20",
    fill: "#CDDFFF",
    transform: "translate(115.169275, 82.485417) rotate(-2.000000) translate(-115.169275, -82.485417) "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.837492,85.385616 C290.477991,92.2499341 283.186847,104.993269 279.96406,123.615621 C275.129879,151.549148 275.820384,188.863478 270.47915,193.902607 C265.137916,198.941737 286.513195,195.235951 293.535827,179.068131 C300.558458,162.900311 305.326,147.398643 303.808293,128.727401 C302.796488,116.279907 302.139554,101.832646 301.837492,85.385616 Z",
    id: "Path-21",
    fill: "#FF655A",
    transform: "translate(286.861166, 140.692202) rotate(17.000000) translate(-286.861166, -140.692202) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.715865,105.496994 C296.188872,144.794702 290.640463,172.280445 278.070637,187.954222",
    id: "Path-22",
    fill: "#FFFFFF",
    opacity: 0.400000006,
    transform: "translate(286.509133, 146.725608) rotate(17.000000) translate(-286.509133, -146.725608) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(56.100000, 86.700000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#0D006A",
    x: 0,
    y: 98.6,
    width: 191.25,
    height: 10.2,
    rx: 2.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5524066,0.11672815 L176.061197,3.6171898 C178.833859,3.67765749 181.05,5.94265639 181.05,8.71597742 L181.05,100.3 L181.05,100.3 L17.7802046,99.1628699 C15.030475,99.1437188 12.7910084,96.948061 12.7175443,94.1992462 L10.34303,5.35176838 C10.2677797,2.53612154 12.4893101,0.19258641 15.3049569,0.117336172 C15.3874231,0.115132203 15.4699306,0.114929469 15.5524066,0.11672815 Z",
    id: "Rectangle",
    fill: "#0F0061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1029252,3.51480162 L172.659352,6.82949922 C175.432753,6.88897901 177.65,9.15428823 177.65,11.9283267 L177.65,98.6 L177.65,98.6 L20.2362915,97.5218549 C17.4872227,97.5030262 15.2477888,95.308644 15.1731035,92.5605254 L12.8954555,8.75218 C12.8189359,5.93656736 15.0394096,3.59203101 17.8550223,3.51551149 C17.9376386,3.51326623 18.0202974,3.51302954 18.1029252,3.51480162 Z",
    id: "Rectangle",
    fill: "#A8C7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9759966,17.0261561 L118.175997,17.6084903 C120.513017,17.6227858 122.4,19.5213466 122.4,21.8584108 L122.4,55.2239234 C122.4,57.5711336 120.49721,59.4739234 118.15,59.4739234 C118.141334,59.4739234 118.132669,59.4738969 118.124003,59.4738439 L22.9240034,58.8915097 C20.5869829,58.8772142 18.7,56.9786534 18.7,54.6415892 L18.7,21.2760766 C18.7,18.9288664 20.6027898,17.0260766 22.95,17.0260766 C22.9586656,17.0260766 22.9673312,17.0261031 22.9759966,17.0261561 Z",
    id: "Rectangle",
    fill: "#C6D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9632442,62.0632855 L169.163244,62.5188866 C171.505272,62.526185 173.4,64.4268263 173.4,66.768866 L173.4,90.0867351 C173.4,92.4339453 171.49721,94.3367351 169.15,94.3367351 C169.145585,94.3367351 169.141171,94.3367283 169.136756,94.3367145 L22.9367558,93.8811134 C20.5947275,93.873815 18.7,91.9731737 18.7,89.631134 L18.7,66.3132649 C18.7,63.9660547 20.6027898,62.0632649 22.95,62.0632649 C22.9544147,62.0632649 22.9588294,62.0632717 22.9632442,62.0632855 Z",
    id: "Rectangle-Copy-12",
    fill: "#C6D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.106631,17.0573911 L169.206631,17.5784466 C171.531549,17.609429 173.4,19.5029453 173.4,21.8280693 L173.4,55.1929862 C173.4,57.5401964 171.49721,59.4429862 169.15,59.4429862 C169.131122,59.4429862 169.112245,59.4428604 169.093369,59.4426089 L129.993369,58.9215534 C127.668451,58.890571 125.8,56.9970547 125.8,54.6719307 L125.8,21.3070138 C125.8,18.9598036 127.70279,17.0570138 130.05,17.0570138 C130.068878,17.0570138 130.087755,17.0571396 130.106631,17.0573911 Z",
    id: "Rectangle",
    fill: "#C6D9FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M283.648088,82.6071329 C272.336454,89.5092296 265.060509,102.297069 261.820252,120.970652 C256.959867,148.981026 257.577202,186.384732 252.255102,191.446026 C246.933002,196.50732 268.201056,192.752824 275.216299,176.532678 C282.231542,160.312532 287.002495,144.764345 285.527659,126.05056 C284.544435,113.574703 283.917911,99.0935609 283.648088,82.6071329 Z",
    id: "Path-21-Copy",
    fill: "#E64353",
    transform: "translate(268.602737, 138.076523) rotate(-1.000000) translate(-268.602737, -138.076523) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.656449,102.904507 C278.066882,142.178752 272.428255,169.660455 259.740568,185.349615",
    id: "Path-22-Copy",
    fill: "#FFFFFF",
    opacity: 0.400000006,
    transform: "translate(268.304338, 144.127061) rotate(-1.000000) translate(-268.304338, -144.127061) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-77"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-75",
    transform: "translate(11.216772, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.1276232,64.9045342 L97.4120612,63.3353535 L93.1583825,48.156962 C92.820592,46.9516247 91.6578595,46.1696997 90.4141408,46.3114891 L83.046556,47.151426 L83.046556,47.151426 L84.005259,50.8605668 L90.6065242,49.8304907 L95.1276232,64.9045342 Z",
    id: "Path-51",
    fill: "#5746FF",
    transform: "translate(90.229309, 55.484995) scale(-1, 1) rotate(76.000000) translate(-90.229309, -55.484995) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.14291,58.1653647 L106.437017,56.6070487 L102.140793,41.4951293 C101.8001,40.2967445 100.643338,39.5199928 99.4051525,39.6581803 L91.9775316,40.487139 L91.9775316,40.487139 L92.9458546,44.1786521 L99.5795237,43.1621695 L104.14291,58.1653647 Z",
    id: "Path-51",
    fill: "#5746FF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#3420FA",
    transform: "translate(31.119860, 18.866276) rotate(70.000000) translate(-31.119860, -18.866276) ",
    points: "26.196253 -10.5741771 37.4955596 -11.3606512 38.2951851 48.6215521 23.9445355 49.0932042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5625364,-2.06197543 C33.5438809,-2.20600143 35.2668342,-0.716560458 35.4108602,1.26478409 C35.4160665,1.33640723 35.4191268,1.40817022 35.420037,1.47997656 L35.8462067,35.1018996 C35.8803021,37.7917923 33.7583709,40.0157478 31.0698415,40.1079168 C28.5798764,40.1932785 26.4921615,38.2439624 26.4067998,35.7539973 C26.4031712,35.6481509 26.4032711,35.5422096 26.4070994,35.4363703 L27.6153884,2.03156164 C27.6939427,-0.140181861 29.3950915,-1.9044216 31.5625364,-2.06197543 Z",
    id: "Rectangle-Copy-33",
    fill: "#8AB2FF",
    transform: "translate(31.069842, 18.967451) rotate(70.000000) translate(-31.069842, -18.967451) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-29",
    fill: "#3420FA",
    transform: "translate(70.631233, 20.378371) rotate(146.000000) translate(-70.631233, -20.378371) ",
    points: "65.593402 0.00296414667 73.8168682 -0.137744646 75.9640635 40.6624455 65.2984027 40.8944857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4861635,12.2731847 C74.6057916,12.2491434 75.5394761,13.1240694 75.5881581,14.242897 L76.4500724,34.0517329 C76.5118029,35.4704461 75.4117511,36.6705828 73.9930379,36.7323133 C73.9790463,36.7329221 73.96505,36.7334166 73.9510504,36.7337967 C72.5544048,36.7717167 71.3914596,35.6702521 71.3535396,34.2736065 C71.3527937,34.2461348 71.3524955,34.2186528 71.3526452,34.1911714 L71.4607853,14.3312809 C71.4668916,13.2098499 72.3649743,12.2972596 73.4861635,12.2731847 Z",
    id: "Rectangle-Copy-34",
    fill: "#8AB2FF",
    transform: "translate(73.951050, 24.517331) rotate(146.000000) translate(-73.951050, -24.517331) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#190086",
    cx: 88.2386076,
    cy: 43.88125,
    rx: 5.98227848,
    ry: 5.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8129947,39.642757 L91.6653972,39.0881625 C92.4355849,39.0488033 93.1357812,39.5328189 93.371091,40.2672355 L93.7269815,41.3779922 C94.013458,42.2721032 93.5208728,43.2291585 92.6267618,43.515635 C92.4841207,43.5613377 92.336065,43.5879886 92.1864404,43.5948954 L80.8085631,44.120109 C79.8706777,44.1634026 79.0752749,43.4381928 79.0319813,42.5003074 C79.0267068,42.3860445 79.032978,42.2715411 79.0506995,42.1585377 L79.2202838,41.0771619 C79.3449197,40.2824048 80.0095725,39.6838146 80.8129947,39.642757 Z",
    id: "Rectangle-Copy-30",
    fill: "#3420FA",
    transform: "translate(86.566250, 41.618772) rotate(147.000000) translate(-86.566250, -41.618772) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0644665,36.7416512 L89.2314926,36.2946757 C89.9943462,36.2641415 90.683989,36.7459098 90.9177999,37.4726907 L91.1420136,38.1696392 C91.4020201,38.9778467 90.9576154,39.8438052 90.149408,40.1038117 C90.0167123,40.1465009 89.8788269,40.1709435 89.739543,40.1764674 L78.4328084,40.6248841 C77.6308701,40.6566884 76.9159318,40.1233162 76.7179682,39.3455457 L76.5664738,38.7503461 C76.3468345,37.8874148 76.8683257,37.009818 77.7312569,36.7901787 C77.8403285,36.762417 77.9520073,36.7461525 78.0644665,36.7416512 Z",
    id: "Rectangle-Copy-31",
    fill: "#7292F9",
    transform: "translate(83.918647, 38.461221) rotate(147.000000) translate(-83.918647, -38.461221) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#3420FA",
    strokeWidth: 1.7,
    fill: "#FF655A",
    cx: 62.0661392,
    cy: 6.69375,
    rx: 7.58006329,
    ry: 7.54375
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#3420FA",
    strokeWidth: 2.55,
    fill: "#FF655A",
    cx: 8.97341772,
    cy: 31.2375,
    rx: 10.2484177,
    ry: 10.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-61",
    transform: "translate(209.100000, 116.450000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.27885551,0.185241866 L52.8788555,1.85558742 C55.6242073,1.95192536 57.8,4.20540871 57.8,6.95245025 L57.8,82.1211614 C57.8,84.9378136 55.5166522,87.2211614 52.7,87.2211614 L5.1,87.2211614 C2.28334778,87.2211614 2.12129725e-15,84.9378136 0,82.1211614 L0,5.2821047 C-1.23311883e-15,2.46545247 2.28334778,0.182104696 5.1,0.182104696 C5.15963226,0.182104696 5.21925993,0.18315058 5.27885551,0.185241866 Z",
    id: "Rectangle",
    fill: "#130072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19296884,5.48023877 L52.4608015,7.22481505 C53.8569342,7.27862058 54.9497921,8.44588983 54.9116496,9.8425382 L53.1972341,72.6184684 C53.1595271,73.9991663 52.0293972,75.0988537 50.6481845,75.0988537 L5.21166926,75.0988537 C3.80334315,75.0988537 2.66166926,73.9571798 2.66166926,72.5488537 C2.66166926,72.5240521 2.66203109,72.4992519 2.66275464,72.4744609 L4.54585271,7.95395446 C4.58693868,6.54622778 5.76143338,5.4383466 7.16916005,5.47943256 C7.17709753,5.47966423 7.18503388,5.47993297 7.19296884,5.48023877 Z",
    id: "Rectangle",
    fill: "#A8C7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C6D9FF",
    x: 6.34390244,
    y: 18.5280844,
    width: 25.3756098,
    height: 21.5507692,
    rx: 2.55
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-24",
    fill: "#C6D9FF",
    x: 6.34390244,
    y: 42.0992383,
    width: 44.4073171,
    height: 14.8161538,
    rx: 2.55
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-25",
    fill: "#C6D9FF",
    x: 6.34390244,
    y: 58.9357767,
    width: 44.4073171,
    height: 13.4692308,
    rx: 2.55
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-23",
    fill: "#C6D9FF",
    x: 33.1292683,
    y: 18.5280844,
    width: 19.0317073,
    height: 21.5507692,
    rx: 2.55
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 217.175,
    cy: 129.625,
    r: 1.275
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 221.425,
    cy: 129.625,
    r: 1.275
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 225.675,
    cy: 129.625,
    r: 1.275
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrototyping3X);
export default __webpack_public_path__ + "static/media/Prototyping@3x.19f65c2229565fcd0a875b7f7911bf1b.svg";
export { ForwardRef as ReactComponent };